"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useMobileDeviceType() {
    const [isMobileDevice, setIsMobileDevice] = react_1.useState(false);
    react_1.useEffect(() => {
        if (navigator.userAgent.includes('iPhone') ||
            navigator.userAgent.includes('iPad') ||
            navigator.userAgent.includes('Mobile') ||
            navigator.userAgent.includes('mobile') ||
            navigator.userAgent.includes('Android') ||
            navigator.platform === 'MacIntel') {
            setIsMobileDevice(true);
        }
        else {
            setIsMobileDevice(false);
        }
    }, [isMobileDevice]);
    return isMobileDevice;
}
exports.default = useMobileDeviceType;
//# sourceMappingURL=useMobileDevice.js.map